
















































import Vue from 'vue'
import { DxHtmlEditor, DxItem, DxMediaResizing, DxTableContextMenu, DxToolbar } from 'devextreme-vue/html-editor'

interface ComponentData {
  body: string
  sizeValues: any
  fontValues: any
  headerValues: any
  fontSizeOptions: any
  fontFamilyOptions: any
  headerOptions: any
}

export default Vue.extend({
  name: 'TicketingTextEditor',

  components: {
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxTableContextMenu,
    DxItem
  },

  props: {
    areaHeight: Number
  },

  data (): ComponentData {
    return {
      body: '',
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5],
      fontSizeOptions: { inputAttr: { 'aria-label': 'Font size' } },
      fontFamilyOptions: { inputAttr: { 'aria-label': 'Font family' } },
      headerOptions: { inputAttr: { 'aria-label': 'Font family' } }
    }
  },

  computed: {

  },

  methods: {

  },

  mounted () {

  }
})
